// Function index:
//   QuestWaypoint                   — a giver reduced to what the map draws.
//   questWaypoints(quests, worldId) — which quest givers to mark.
//
// Pure and DOM-free so the filtering rules — the part with real edge cases —
// are testable without an SVG. strategic-map.ts owns the drawing.

import type { Quest } from '../api/types.js';

export interface QuestWaypoint {
  q: number;
  r: number;
  title: string;
  giver: string;
  ready: boolean;
}

// Filtered to THIS overworld: interiors are child world rows sharing the hex
// grid, so a giver inside a cave would otherwise be plotted on the surface
// directly above them. Dead and missing givers are dropped — there is nowhere
// to send the party. Two quests from one giver collapse to a single marker;
// two arrows on one hex is just noise.
export function questWaypoints(quests: Quest[], worldId: number): QuestWaypoint[] {
  const byHex = new Map<string, QuestWaypoint>();
  for (const q of quests) {
    if (q.status !== 'active' && q.status !== 'ready') continue;
    const g = q.giver;
    if (!g || !g.alive || g.world_id !== worldId) continue;
    const key = `${g.q},${g.r}`;
    const existing = byHex.get(key);
    if (existing) {
      existing.title += `; ${q.title}`;
      existing.ready = existing.ready || q.status === 'ready';
      continue;
    }
    byHex.set(key, { q: g.q, r: g.r, title: q.title, giver: g.name, ready: q.status === 'ready' });
  }
  return [...byHex.values()];
}
